import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { Chip } from "@material-ui/core";

import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Button, MenuItem } from "@material-ui/core";
import FileBase from "react-file-base64";
import { red, green, blue } from "@material-ui/core/colors";

import { useDispatch, useSelector } from "react-redux";
import {
  propertyFetchThunk,
  propertyUpdateThunk,
} from "../../features/properties/properties";

//hooks
import useModal from "../../Hooks/useModal";

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});

const col = [
  "Title",
  "Author Name",
  "Status",
  "Area",
  "Size",
  "Edit",
  "Delete",
];

const getBadge = (status) => {
  switch (status) {
    case "approved":
      return green[500];
    case "pending":
      return blue[500];
    case "rejected":
      return red[500];
    default:
      return "primary";
  }
};

export default function PropertiesApproval() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { handleShow, handleClose, open } = useModal();
  const [Editdata, setEditdata] = React.useState(null);

  const propertyState = useSelector((state) => state.properties);

  React.useEffect(() => {
    dispatch(propertyFetchThunk());
    return () => {};
  }, []);

  return (
    <>
      <TableContainer className="mt-4" component={Paper}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              {col.map((item, i) => (
                <TableCell key={i} align={item == "Title" ? "left" : "center"}>
                  {item}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {propertyState.properties.map((row, i) => (
              <TableRow key={i}>
                <TableCell component="th" scope="row">
                  {row.title}
                </TableCell>
                <TableCell align="right">{row.authorName}</TableCell>
                <TableCell align="right">
                  <Chip
                    label={row.status}
                    style={{
                      backgroundColor: getBadge(row.status),
                      color: "#fff",
                    }}
                  />
                </TableCell>
                <TableCell align="right">{row.area}</TableCell>
                <TableCell align="right">{row.size}</TableCell>
                <TableCell align="right">
                  <Button
                    variant="contained"
                    color="primary"
                    style={{ backgroundColor: "#F0D500" }}
                    onClick={() => {
                      dispatch(propertyUpdateThunk(row, "approved"));
                      console.log(row, "approve Property");
                    }}
                  >
                    Approve
                  </Button>
                </TableCell>
                <TableCell align="right">
                  <Button
                    variant="contained"
                    color="primary"
                    style={{ backgroundColor: "#F32013" }}
                    onClick={() => {
                      dispatch(propertyUpdateThunk(row, "rejected"));
                      console.log(row, "suspend Property");
                    }}
                  >
                    Suspend
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Entry open={open} handleClose={handleClose} Editdata={Editdata} />
    </>
  );
}

export const Entry = ({ handleClose, open, Editdata }) => {
  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {Editdata ? "Edit Property" : "Add Property"}
        </DialogTitle>
        <DialogContent></DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleClose} color="primary">
            Subscribe
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
